import { Directive, HostBinding, Input } from '@angular/core';

export type ButtonStyle =
  | 'default'
  | 'emphasis'
  | 'alert'
  | 'tertiary'
  | 'default-reversed';

/**
 * Basic button component
 */

@Directive({
  selector: 'button[i2gButton],a[i2gButton]',
})
export class ButtonDirective {
  @Input() buttonStyle: ButtonStyle = 'default';

  constructor() {}

  @HostBinding('class.button-style-default')
  get default() {
    return this.buttonStyle === 'default';
  }

  @HostBinding('class.button-style-emphasis')
  get emphasis() {
    return this.buttonStyle === 'emphasis';
  }

  @HostBinding('class.button-style-alert')
  get alert() {
    return this.buttonStyle === 'alert';
  }

  @HostBinding('class.button-style-tertiary')
  get tertiary() {
    return this.buttonStyle === 'tertiary';
  }

  @HostBinding('class.button-style-default-reversed')
  get defaultReversed() {
    return this.buttonStyle === 'default-reversed';
  }
}
